export default {
  //header
  'Services': "Қызметтер",
  'Expertise': "Құзырет",
  'Industries': 'Салалар',
  'Our team': 'Біздің команда',
  'Our Projects': 'Біздің жобалар',



  ///Expertise
  'Who we are': 'Біз кімбіз',

  'Who we are Text1': "JaiyqDev — жаһандық технологиялық серіктес, салаларды түрлендіріп, бизнеске, адамдарға және жаһандық қоғамдастыққа ұзақ мерзімді құндылық әкелетін өзгерістерді басқарады.",
  'Who we are Text2': "Олар бізге ең қиын мәселелерге шешім табуға және өзгермелі нарық ортасында мағыналы инновацияларға қол жеткізу жолында кедергілерді жоюға сенім артады.",
  'Who we are Text3': "Нарықтағы 20 жылдық тәжірибеге сүйене отырып, JaiyqDev клиенттердің жетістігіне деген құштарлығы мен адамдарға бағытталған тәсілі инженерлерді, жасаушыларды және жаңашылдарды Еуропа, Солтүстік Америка және Таяу Шығыста біріктіреді.",

  'Engineers Text1': "Инженерлер",
  'Engineers Text2': "өз мамандарымыз",

  'Expertise/Countries Text1': "Клиенттер орналасқан",
  'Expertise/Countries Text2': "елдер",

  'Expertise/Experience Text1': "Жыл",
  'Expertise/Experience Text2': "тәжірибе",

  'Expertise/Senior Text1': "Сеньор",
  'Expertise/Senior Text2': "инженерлер",

  'Expertise/Our missions Text1': "Біздің миссияларымыз",
  'Expertise/Our missions Text2': "Біз керемет идеяларды сандық технологияның",
  'Expertise/Our missions Text3': "күшімен жүзеге асырамыз",




  ///Information
  "Information/Text1": "JaiyqDev кеңселерінде",
  "Information/Text2": "ақылды жайлылық",
  "Information/Text3": "JaiyqDev — жоғарғы деңгейдегі ұйымдар мен Fortune 500 компанияларының тұрақты жетістіктеріне қол жеткізуге мүмкіндік беретін жаһандық технологиялық серіктес.",
  "Information/Text4": "Біз технологияның күші арқылы серіктестерімізге және клиенттерімізге құндылық жеткізе отырып, олардың цифрлық бастамаларының сәтті болатынына сенім береміз. Олар бізге ең қиын мәселелерді шешіп, динамикалық нарықта мағыналы инновацияларға қол жеткізу жолындағы кедергілерді жоюға сенім артады.",



  ///CompanyStaff
  "CompanyStaff/Text1": "Біздің командамызбен танысыңыз",



  ///OurProjects
  "OurProjects/Text1": "Біздің жобаларымыз",



  ///Project
  "Project/Summary": "Қорытынды:",
  "Project/Client": "Клиент",
  "Project/Country": "Ел",
  "Project/Industry": "Сала",
  "Project/Type of service": "Қызмет түрі",
  "Project/What we've challenged to do": "Біз не істедік",
  "Project/What we've done": "Не жасадық",
  "Project/What we've delivered": "Не жеткіздік",
  "Project/Stacks used": "Пайдаланылған стек",
  "Project/Resources used": "Пайдаланылған ресурстар",
  "Project/delivered app for iOS": "iOS үшін жеткізілген қолданба",
  "Project/delivered app for android": "Android үшін жеткізілген қолданба",



  ///Footersec

  "Footersec/You find us": "Бізді табыңыз",
  "Footersec/Visit": "Келіңіз",
  "Footersec/Oral kalasy, Eskalieva 179": "Орал қаласы, Ескалиева 179",



  ///Projects

  // Жоба 1
  "Projects/projectId1WhatOurClientDo": "Шетелдік онлайн-дүкендерден сатып алынған тауарларды есігіңізге дейін жеткізетін қызмет",
  "Projects/projectId1Country": "АҚШ/Қазақстан",
  "Projects/projectId1Industry": "Сауда, жеткізу",
  "Projects/projectId1TypeOfService": "Аутсорсинг",
  "Projects/projectId1WhatChallengedToDoMainText": "Біздің міндетіміз iOS, Android және веб-қосымша жасау болды, онда пайдаланушы келесілерді жасай алады:",
  "Projects/projectId1WhatChallengedToDoList1": "- сәлемдеме жасау",
  "Projects/projectId1WhatChallengedToDoList2": "- сәлемдеменің мәліметтері мен бақылау нүктелерін тексеру",
  "Projects/projectId1WhatChallengedToDoList3": "- карта арқылы немесе Apple Pay арқылы баланс толтыру",
  "Projects/projectId1WhatDoneMainText": "Жұмыс процесі келесідей болды:",
  "Projects/projectId1WhatDoneList1": "1. Жобаның ауқымын талдау, әзірлеу жоспарын жасау",
  "Projects/projectId1WhatDoneList2": "2. Команда мүшелерінің міндеттерін анықтау",
  "Projects/projectId1WhatDoneList3": "3. Дизайнды жүзеге асыру",
  "Projects/projectId1WhatDoneList4": "4. Көп платформалы қосымшаны іске қосу",
  "Projects/projectId1WhatDeliveredMainText": "Жол картасын құру (2 апта), MVP жасау (3,5 ай). Алғашқы клиенттерден, сатушылардан және Shipper компаниясының бэк-офисінен кері байланыс жинау (2 ай). Жиналған деректер негізінде өнімді одан әрі дамыту. Қосымша қарапайым, пайдалануға ыңғайлы және мобильді құрылғыларда және планшеттерде жылдам жұмыс істейді. Біздің жұмысымыздың нәтижесінде Shipper пайдаланушылары қажетті сәлемдемелерді іздей алады, бақылау нүктелерінің мәліметтерін көре алады және картамен немесе Apple Pay арқылы баланс толтыра алады.",
  "Projects/projectId1StacksUsed": "Мобильді қосымша әзірлеу, Веб-әзірлеу, React Native, React, Redux-toolkit, REST API, Firebase, Push хабарландырулар, Deep linking, Картамен төлем, Apple Pay, CloudPayments",
  "Projects/projectId1ResourcesUsed": "2 мобильді әзірлеуші, 1 жоба менеджері, 1 қолмен тестілеуші, 1 веб/мобиль дизайнер",
  "Projects/projectId1Duration": "7+ ай",

  // Жоба 2
  "Projects/projectId2WhatOurClientDo": "Криптовалюта, трейдинг, трейдерлерге арналған әлеуметтік желі",
  "Projects/projectId2Country": "АҚШ",
  "Projects/projectId2Industry": "Криптовалюта, трейдинг",
  "Projects/projectId2TypeOfService": "Аутстафф",
  "Projects/projectId2WhatChallengedToDoMainText": "Earnity-де толық функционалды веб-қосымша болды. Нарықтағы өзгерістер мен пайдаланушылардың қажеттіліктеріне байланысты клиент мобильді қосымшаны Android және iOS платформаларына қосу қажеттігін айтты. Пайдаланушылар веб-қосымшамен таныс болғандықтан, жобаның басты қиыншылығы мобильді нұсқада сол мүмкіндіктер мен тәжірибені ұсыну болды. Ұсынылған қосымша жылдам, ауқымды және клиент ұсынған API-мен тиімді интеграциялануы керек болды. Клиент бізге соңғы дизайнды және функционалдық талаптарды ұсынды, бірақ бағдарламалық жасақтама жасау процесінде көп тәжірибесі болмады.",
  "Projects/projectId2WhatDoneMainText": "Жұмыс процесі келесідей болды:",
  "Projects/projectId2WhatDoneList1": "1. Жобаның ауқымын талдау, әзірлеу және дизайн жоспарын дайындау",
  "Projects/projectId2WhatDoneList2": "2. Команда мүшелерінің міндеттерін анықтау",
  "Projects/projectId2WhatDoneList3": "3. Дизайнды жүзеге асыру",
  "Projects/projectId2WhatDoneList4": "4. Даму процесін бастау",
  "Projects/projectId2WhatDeliveredMainText": "Earnity іске қосылғаннан кейін келесі мүмкіндіктер өте қызықты болды:",
  "Projects/projectId2WhatDeliveredList1": "- Jumio SDK көмегімен пайдаланушының идентификациясын тексеру",
  "Projects/projectId2WhatDeliveredList2": "- Stripe төлем жүйесі арқылы токендерді төлеу",
  "Projects/projectId2WhatDeliveredList3": "- GetStream.io көмегімен әлеуметтік желі, белсенділік таспалары мен чат қолданбалары",
  "Projects/projectId2WhatDeliveredList4": "- Push хабарландырулар",
  "Projects/projectId2StacksUsed": "Мобильді қосымша әзірлеу, React Native, React Sweet state, getstream.io, Jumio SDK, Stripe SDK",
  "Projects/projectId2ResourcesUsed": "1 React Native әзірлеуші",
  "Projects/projectId2Duration": "11+ ай",

  // Жоба 3
  "Projects/projectId3WhatOurClientDo": "Қосымша жүкті әйелдерге және бір жасқа дейінгі балалары бар аналарға арналған.",
  "Projects/projectId3Country": "Қазақстан",
  "Projects/projectId3Industry": "Медициналық",
  "Projects/projectId3TypeOfService": "Аутсорсинг",
  "Projects/projectId3WhatChallengedToDoMainText": "Біздің міндетіміз Android және iOS платформаларына арналған қосымшаны жасау болды, онда пайдаланушы:",
  "Projects/projectId3WhatChallengedToDoList1": "- клиникадан тағайындалған дәрігерімен онлайн чат/бейнеқоңырау жасай алады",
  "Projects/projectId3WhatChallengedToDoList2": "- пайдаланушылар өз білімдерімен бөлісіп, қызықты жаңалықтарды жариялай алатын әлеуметтік желі",
  "Projects/projectId3WhatChallengedToDoList3": "- денсаулық сынағы",
  "Projects/projectId3WhatDoneMainText": "Жұмыс процесі келесідей болды:",
  "Projects/projectId3WhatDoneList1": "1. Жобаның ауқымын талдау, әзірлеу және дизайн жоспарын дайындау",
  "Projects/projectId3WhatDoneList2": "2. Команда мүшелерінің міндеттерін анықтау",
  "Projects/projectId3WhatDoneList3": "3. Дизайнды жүзеге асыру",
  "Projects/projectId3WhatDoneList4": "4. Даму процесін бастау",
  "Projects/projectId3WhatDeliveredMainText": "Сегіз ай ішінде біз Supermom Academy құрдық - бұл кросс-платформалы қосымша, ол жедел жәрдемге қоңырау шалуды жеңілдетеді. Пайдаланушы дәрігермен чат/бейнеқоңырау жасай алады. Қосымша арқылы пайдаланушы жазбаларды оқып, оларды бөлісе алады, лайк қоя алады, пікір жаза алады.",
  "Projects/projectId3StacksUsed": "Мобильді қосымша әзірлеу, React Native",
  "Projects/projectId3ResourcesUsed": "1 мобильді әзірлеуші, 1 тестер, 1 жоба менеджері, 1 backend әзірлеуші",
  "Projects/projectId3Duration": "8 ай",

  // Жоба 4
  "Projects/projectId4WhatOurClientDo": "Бизнеске арналған шешімдер: онлайн касса, QR төлемдер, сәлемдеме терминалдарына жеткізу және т.б.",
  "Projects/projectId4Country": "Қазақстан",
  "Projects/projectId4Industry": "Бизнес",
  "Projects/projectId4TypeOfService": "Аутстафф",
  "Projects/projectId4WhatChallengedToDoMainText": "Біздің міндетіміз Android және iOS үшін қосымша жасау болды, ол кассалық аппарат ретінде қызмет етеді, мұнда бизнес төлем қабылдау, төлемдерді қайтару, QR төлемдер жасау, bluetooth принтер арқылы чектерді басып шығару, төлем тарихын тексеру сияқты әрекеттерді орындай алады.",
  "Projects/projectId4WhatDeliveredMainText": "Қорытындысында біз мобильді кассалық аппарат жасадық. Бизнес төлемдерді қабылдап, қажет болған жағдайда төлемдерді қайтарып, bluetooth принтер арқылы чектерді басып шығарып, күнделікті/апта сайынғы/ай сайынғы есептерді жасай алады.",
  "Projects/projectId4StacksUsed": "React Native, Typescript, Redux toolkit, REST API, Firebase, Push хабарландырулар, Deep linking қолданатын мобильді қосымша әзірлеу",
  "Projects/projectId4ResourcesUsed": "1 React Native әзірлеуші",
  "Projects/projectId4Duration": "18+ ай",

  // Жоба 5
  "Projects/projectId5WhatOurClientDo": "Culdesac - жанкүйерлерге өз дауыстарын қайтаратын спорттық әлеуметтік желі.",
  "Projects/projectId5Country": "АҚШ",
  "Projects/projectId5Industry": "Спорт",
  "Projects/projectId5TypeOfService": "Аутстафф",
  "Projects/projectId5WhatChallengedToDoMainText": "Басты тапсырма - пайдаланушылар спорттық оқиғалар туралы жарияланымдар жариялайтын, пікірталасқа түсетін, пікір білдіретін, пікірлермен келісетін және келіспейтін reddit сияқты қолданба жасау болды.",
  "Projects/projectId5WhatDeliveredMainText": "Қорытындысында біз журналистерге, бұрынғы спортшыларға немесе орташа жанкүйерге арналған мобильді қосымша жасадық. Пайдаланушылар посттарға лайк қоя алады, пікір жаза алады, келіседі, келіспейді. Ең көп лайк жинаған посттар танымалдар тізімінде көрсетіледі.",
  "Projects/projectId5StacksUsed": "React Native, Typescript, Redux toolkit, REST API, Firebase, Push хабарландырулар, Deep linking қолданатын мобильді қосымша әзірлеу",
  "Projects/projectId5ResourcesUsed": "1 React Native әзірлеуші",
  "Projects/projectId5Duration": "5 ай",

  // Жоба 6
  "Projects/projectId6WhatOurClientDo": "Атаулы артықшылықтар бағдарламасы, атқарушы тұлғалардың өмір сүру сапасын жақсартуға арналған.",
  "Projects/projectId6Country": "АҚШ",
  "Projects/projectId6Industry": "Бизнес",
  "Projects/projectId6TypeOfService": "Аутстафф",
  "Projects/projectId6WhatChallengedToDoMainText": "Міндетіміз - пайдаланушылар түрлі артықшылықтарды пайдалана алатын iOS/Android қосымшасын жасау болды.",
  "Projects/projectId6WhatDeliveredMainText": "Қосымша іске қосылғаннан кейін EXEC пайдаланушылары жүздеген артықшылықтардың эксклюзивті топтамасы арқылы қонақжайлылықтың жоғары деңгейіне және келісілген бағаға қол жеткізе алады. EXEC адамдарға бұрын қол жетімсіз болған тәсілдермен өмірін жақсартуға көмектеседі.",
  "Projects/projectId6StacksUsed": "React Native, Typescript, Redux Toolkit, GraphQL, Firebase, Push хабарландырулар, Deep linking қолданатын мобильді қосымша әзірлеу",
  "Projects/projectId6ResourcesUsed": "1 React Native әзірлеуші",
  "Projects/projectId6Duration": "6-8 ай",

  // Жоба 7
  "Projects/projectId7WhatOurClientDo": "Әлемдегі ең жоғары сапалы ерлер киімдері мен аксессуарларын жасайтын және жеткізетін мүшелікке негізделген сән бренді.",
  "Projects/projectId7Country": "АҚШ",
  "Projects/projectId7Industry": "Сән дизайны",
  "Projects/projectId7TypeOfService": "Аутстафф",
  "Projects/projectId7WhatChallengedToDoMainText": "Қосымшаның басты қиындығы - тапсырыс берушінің сұрауы бойынша анимациялық дизайнды жүзеге асыру болды. Тағы бір міндет - қолданушыға коллекцияны жеткізу әр кезеңінде хабарлама жіберіп тұру.",
  "Projects/projectId7WhatDeliveredMainText": "Қорытындысында біз әдемі кросс-платформалы қосымшаны жасадық. Пайдаланушылар қосымшаға несие карталарын сақтап, әдепкі картаны таңдап, мүшелік үшін төлем жасай алады.",
  "Projects/projectId7StacksUsed": "React Native, Typescript, Redux Toolkit, REST API, Firebase, Push хабарландырулар, Deep linking қолданатын мобильді қосымша әзірлеу",
  "Projects/projectId7ResourcesUsed": "1 React Native әзірлеуші",
  "Projects/projectId7Duration": "8+ ай",
}